/**
 * @fileoverview Provides a user input function that accepts either a direct string argument or prompts the user interactively using terminal input or a text editor. Handles fallback to an editor input when no initial input is provided, supporting flexible text entry methods.
 */

import { editor, input } from '@inquirer/prompts'
import { print_user } from '@iterator/shared-node/util/logging'

export async function getUserInput(promptArg: string | undefined): Promise<string> {
  if (promptArg) {
    return promptArg
  }

  let answer = await input({ message: '' })
  if (answer === '') {
    answer = await editor({
      waitForUseInput: false,
      message: 'Input from editor',
    })
    print_user(answer)
  }
  return answer
}
